import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { SettingsState } from '@app/_state/settings.state';
import { RoleEnum } from '@app/_models/role.enum';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {
  private store = inject(Store);
  private router = inject(Router);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const adminRole = RoleEnum.ADMIN;
    const currentRoles = this.store.selectSnapshot(SettingsState.roles);
    if (currentRoles && currentRoles.indexOf(adminRole) > -1) {
      return true;
    } else {
      this.router.navigate(['/accessdenied']);
      return false;
    }
  }
}
